import '@components/organisms/car-single/car-single-form.scss';
import { createApp } from 'vue';
import LeaseCalculator from './LeaseCalculator.vue';

document.addEventListener( 'DOMContentLoaded', function() {
	const container = document.querySelector( '.js-lease-calculator' );

	if ( container ) {
		const copyConfigRaw = container.dataset.copyConfig || '{}';
		let copyConfig = {};
		try {
			copyConfig = JSON.parse( copyConfigRaw ) || {};
		} catch ( e ) {
			copyConfig = {};
		}

		const app = createApp( LeaseCalculator, { copyConfig } );
		app.mount( container );
	}
} );
